import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';
import HrStore from '../../stores/HrStore'
import SlipContractorDetail from '../hr/slip/SlipContractorDetail'

class PrintSlipContractorDetail extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:[], main_tasklist:[]}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    
  }

  

  renderLogoUrl(){
    let {data} = this.state
    let imgUrl = ''
    let logo_url = ''
    if (data.logo_url!=undefined) {
      logo_url = data.logo_url
      if (process.env.NODE_ENV == "development") {
        imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logo_url
      }else{
        imgUrl = '../'+logo_url
      }
      return (<img src={imgUrl} />)
    }
    return('')
  }

  renderComponentPage() {
    
    let {slipId} = this.props
    return (<div>
      <SlipContractorDetail show={true}  slipId={slipId} />
      </div>
    ) 
    
  }
  
  

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        size={'landscape'}
        leftBarTitle={'สลิปหมายเลข '+this.props.slipId}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}

PrintSlipContractorDetail.defaultProps = {
  title: 'รายการสลิป',  
  periodic:'',
  em:'',
  slipId:''
}

export default PrintSlipContractorDetail;


// WEBPACK FOOTER //
// ./src/view/print/PrintSlipContractorDetail.js